<template>
  <div class="applySuccess">
    <img class="icon" src="@/assets/images/addCar/applySuccess.png"/>
    <p class="tip1">恭喜你 提交成功！</p>
    <p class="tip2">工作人员将在24小时内审核您的资料</p>
    <div class="return" @click="enterIndex" v-if="deviceType == 3">返回首页</div>
    <img class="banner" v-else src="@/assets/images/addCar/downApp.png"/>
  </div>
</template>
<script>
import { deviceType } from "@/utils/env";
import { getCurrentMemberInfo } from "@/utils/api";
export default {
  name: "applySuccess",
  data: function() {
    return {
      deviceType: deviceType,
      userInfo: {
        Name: "姓名",
        Telephone: ""
      }
    };
  },
  created() {
    localStorage.removeItem("cityInfo");
    localStorage.removeItem("addressInfo");
    localStorage.removeItem("memberInfo");
  },
  mounted() {
    this.initData();
  },
  methods: {
    async initData() {
      let res = await getCurrentMemberInfo();
      if (res.Code == 100) {
        this.userInfo = res.Data;
        localStorage.setItem("userInfo", JSON.stringify(res.Data));
      }
    },
    enterIndex() {
      this.$router.replace({ path: "/index" });
    }
  }
};
</script>
<style scoped lang="scss" type="text/css">
.applySuccess {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding-top: 110px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  .icon {
    width: 240px;
    height: 240px;
    margin-top: 54px;
  }
  .tip1 {
    font-size: 26px;
    color: #027fff;
  }
  .tip2 {
    font-size: 26px;
    color: #9f9f9f;
  }
  .banner {
    width: 716px;
    height: 256px;
    margin-top: 125px;
  }
  .return {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 125px;
    width: 400px;
    height: 90px;
    border-radius: 6px;
    background: #027fff;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/car/applySuccess.vue